export enum RouteName {
  HOME = 'Home',
  MINE = 'Mine',
  FRIENDS = 'Friends',
  EARN = 'Earn',
  POC = 'Poc',
  REWARDS = 'Rewards',
  GIVEAWAY = 'Giveaway',
  LEADERBOARD = 'Leaderboard',
  MUI = 'MUI',
  BOOST = 'Boost',
  TOKENS = 'Tokens',
  PROFILE = 'Profile',
  SETTINGS = 'Settings',
  BALANCE = 'Balance',
  SHOP = 'Shop',
  DAILY_REWARDS = 'DailyRewards',
  SKINS = 'Skins',
  TUTORIALS = 'Tutorials',
  MYSTERY_BOX = 'MysteryBox',
  LINGO_GIVEAWAY = 'LingoGiveawayV2',
}

export const routePath: Record<RouteName, string> = {
  [RouteName.HOME]: '/',
  [RouteName.MINE]: '/mine',
  [RouteName.FRIENDS]: '/friends',
  [RouteName.EARN]: '/earn',
  [RouteName.POC]: '/poc',
  [RouteName.REWARDS]: '/rewards',
  [RouteName.GIVEAWAY]: '/giveaway',
  [RouteName.LEADERBOARD]: '/leaderboard',
  [RouteName.MUI]: '/mui',
  [RouteName.BOOST]: '/boost',
  [RouteName.TOKENS]: '/tokens',
  [RouteName.PROFILE]: '/profile',
  [RouteName.SETTINGS]: '/settings',
  [RouteName.BALANCE]: '/balance',
  [RouteName.SHOP]: '/shop',
  [RouteName.DAILY_REWARDS]: '/daily-rewards',
  [RouteName.SKINS]: '/skins',
  [RouteName.TUTORIALS]: '/tutorials',
  [RouteName.LINGO_GIVEAWAY]: '/lingo-giveaway',
  [RouteName.MYSTERY_BOX]: '/mystery-box',
}
